/**
 * ExportacaoContext — modo "exportação" da Conferência de Entrega.
 *
 * Com `expandirTudo`, as seções abrem TODAS as linhas expansíveis e ignoram os filtros
 * (só problemas, por superfície, por dono, por estado) — a tela inteira fica no DOM para
 * a exportação em .html. O estado de cada componente NÃO é alterado: o modo só se soma a
 * ele, então ao sair da exportação a tela volta exatamente como o usuário a deixou.
 *
 * Marcas no DOM lidas pela exportação (`deliveryCheckHtmlExport.js`):
 *   data-export="omitir"   → o elemento sai do arquivo (controle sem sentido offline);
 *   data-export="estatico" → o botão vira texto estático com o mesmo visual.
 * Qualquer outro botão sai do arquivo.
 */
import { createContext, useContext } from 'react';

export const ExportacaoContext = createContext({ expandirTudo: false });

/** `true` enquanto a Conferência está sendo capturada para exportação. */
export function useExpandirTudo() {
  return Boolean(useContext(ExportacaoContext)?.expandirTudo);
}
